// src/components/admin-notary-paid-image.js

import React from 'react';

const NotaryPaidImage = (props) => {
var imagesrc = '/img/us-dollar-unpaid.png'
var hovertext = 'Notary not paid' 

  function convertToSimpleDateMessage(updatedTime) {
    const date = new Date(updatedTime * 1000)
    const dateString = date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })
    return dateString
  }

if (props.notaryPaid){
  var imagesrc = '/img/us-dollar-paid.png'
  var hovertext = convertToSimpleDateMessage(props.notaryPaidTime)
}
else{
  var imagesrc = '/img/us-dollar-unpaid.png'
  var hovertext = 'Notary not paid'
}


  return (
    <img src={imagesrc} title={hovertext} id="myId" width='20' height='20'/>
  );
};

export default NotaryPaidImage;